export default "__VITE_ASSET__DTCPjOrn__"